module.exports = __webpack_public_path__ + "static/media/laurence-kirk.003b89e5.jpg";